/**
 * ⚠️  AUTO-GENERATED — DO NOT EDIT MANUALLY ⚠️
 *
 * Generated by: scripts/preload-query-batch-classifier/index.mjs
 *
 * Per-region SSR preloaded GraphQL query classification using bitmap encoding.
 * Q contains all query names (sorted, with index comments). R maps each SSR
 * region to a hex bitmap where bit i = 1 means Q[i] is fast (batchable).
 *
 * Per-region classification summary (fast/slow/excluded counts) is
 * embedded in the PR description.
 *
 * Thresholds (prod): p90 ≤ 300ms | p95 ≤ 500ms | p99 ≤ 1000ms | min n=100
 * Thresholds (staging): p90 ≤ 600ms | p95 ≤ 1000ms | p99 ≤ 2000ms | min n=100
 * Lookback: last 3 business days
 * Generated: 2026-05-12T22:06:51.053Z
 */

// prettier-ignore
export const Q: readonly string[] = [
	'ActiveCommentsQuery', // 0
	'ApprovalsContextApprovalsDataQuery', // 1
	'ArchivedPageBannerV2ArchivedPageBannerContainerQuery', // 2
	'ArchivedPageBannerV2ArchivedPageBannerQuery', // 3
	'BlogTreeRootComponentQuery', // 4
	'CollabDraftQuery', // 5
	'CollabDraftWithRelevanceQuery', // 6
	'ContentBlogUnifiedQuery', // 7
	'ContentHeaderPresenceContentSettingsQuery', // 8
	'ContentHeaderUnifiedQuery', // 9
	'ContentPrerequisitesQuery', // 10
	'ContentRedirectQuery', // 11
	'ContentTypesHeaderQuery', // 12
	'ContentUnifiedQuery', // 13
	'ContentUnifiedWithSpaceKeyQuery', // 14
	'CookieConsentPreferences', // 15
	'CoverPictureQuery', // 16
	'CustomHeaderFooterQuery', // 17
	'DatabaseContainerQuery', // 18
	'EditContentButtonQuery', // 19
	'EditorContentStateQuery', // 20
	'EditorPreferencesQuery', // 21
	'EmojiTitleQuery', // 22
	'EndOfPageRecommendationQuery', // 23
	'FetchPreFilteredForgeAppsQuery_confluence_contentBylineItem', // 24
	'FetchPreFilteredForgeAppsQuery_confluence_spacePage', // 25
	'FetchPreFilteredForgeAppsQuery_xen_macro', // 26
	'FollowingFeedWithSortByStorageSnippetsQuery', // 27
	'FooterCreateButtonsQuery', // 28
	'ForgeExtensionList', // 29
	'GlobalNavigationComponentQuery', // 30
	'GrantAccessDialogLoaderQuery', // 31
	'HomeRecentWorkQuery', // 32
	'InlineCommentsFocusedInlineCommentQuery', // 33
	'LegacyMacroRendererQueryBodyQuery', // 34
	'LivePagesByLineLastUpdatedQuery', // 35
	'LocalStorageQuery', // 36
	'NativeCollabQuery', // 37
	'NotFoundContainerQuery', // 38
	'NotificationsButtonQuery', // 39
	'ObjectCommentContainerPreloadObjectCommentsQuery', // 40
	'PageRestrictionsContextQuery', // 41
	'PageTreeQuery', // 42
	'PageTreeQueryWithSpaceKeyQuery', // 43
	'PermissionCheckAddCommentQuery', // 44
	'PersistentInviteEligibleQuery', // 45
	'PersonalizedTemplatesV2AllTemplatesQuery', // 46
	'PopularFeedWithTimeGranularityStorageSnippetsQuery', // 47
	'Preferences', // 48
	'PremiumTrialEotQuery', // 49
	'ReactionsContentQuery', // 50
	'RendererContentStateQuery', // 51
	'RestrictedPageWithCanViewQuery', // 52
	'ScreenQuery', // 53
	'SiteInformationQuery', // 54
	'SmartCreateFeedbackBannerQuery', // 55
	'SmartCreatePageEditorDataWrapperComponentQuery', // 56
	'SpaceNavigationQuery', // 57
	'SpaceOverviewIdQuery', // 58
	'SpaceOverviewQuery', // 59
	'SpaceQuery', // 60
	'SpaceRestrictionCheckQuery', // 61
	'ThemeQuery', // 62
	'TopNavigationQuery', // 63
	'UserSettingsQuery', // 64
	'ViewSpaceExternalCollaboratorsDialogQuery', // 65
	'WebItemLocationQuery_page.metadata.banner', // 66
	'WebItemLocationQuery_system.content.byline', // 67
	'WebItemLocationQuery_system.header_left', // 68
	'WebItemLocationQuery_system.header_left_system.user', // 69
	'WebPanelLocationQuery_atl.footer', // 70
	'WebPanelLocationQuery_atl.general', // 71
	'WebPanelLocationQuery_atl.general_atl.footer', // 72
	'WebPanelLocationQuery_atl.page.content.footer.actions', // 73
	'WebStorageCategories', // 74
	'WelcomeMessagesQuery', // 75
	'WhiteboardUnifiedQuery', // 76
	'contentAppearanceQuery', // 77
	'contentSmartLinksORS', // 78
	'fetchMentionsProviderDataQuery', // 79
	'graphqlHelpersDSPIsActionEnabledForContentQuery', // 80
	'graphqlHelpersFetchMediaTokenQuery', // 81
	'multiMacroQueryWithAppKeyQuery', // 82
	'onboardingStateGetOnboardingStateQuery', // 83
	'onboardingStateGetOnboardingStateQuery_aifc-onboarding_hasSeenAIFCSpotlight_8', // 84
	'onboardingStateGetOnboardingStateQuery_auto-page-emoji_emojiTitleDiscovered', // 85
	'onboardingStateGetOnboardingStateQuery_create-with-rovo-announcement-splash_hasSeenSplashModal', // 86
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_2', // 87
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_4', // 88
	'onboardingStateGetOnboardingStateQuery_creation-focused-nav_shouldShowSpotlight_6', // 89
	'onboardingStateGetOnboardingStateQuery_cross-join-nth-user-onboarding_trendingPages', // 90
	'onboardingStateGetOnboardingStateQuery_editor-state_editorOnboardingEligiblity_12', // 91
	'onboardingStateGetOnboardingStateQuery_land-users-in-editor-with-revamped-bpqa_revampedBpqaShownAt', // 92
	'onboardingStateGetOnboardingStateQuery_onboarding-intent-experiences_onboardingIntentExperienceClosed_18', // 93
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_66', // 94
	'onboardingStateGetOnboardingStateQuery_onboarding-origin-state_attributes_67', // 95
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin', // 96
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_10', // 97
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_5', // 98
	'onboardingStateGetOnboardingStateQuery_onboarding-state_isFoundingAdmin_6', // 99
	'onboardingStateGetOnboardingStateQuery_onboarding-state_nthUserOnboardingCompletedTimestamp', // 100
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_152', // 101
	'onboardingStateGetOnboardingStateQuery_storage-enforcement-state_flagsDismissedFreeThreshold_153', // 102
	'pageButtons', // 103
	'preloadAutohighlightsQuery', // 104
	'preloadContentSmartLinksQuery', // 105
	'preloadCreateSpaceQuery', // 106
	'preloadEditButtonWithSpaceKeyQuery', // 107
	'preloadEditorNodeDataProvidersDataQuery', // 108
	'preloadLegacyBridgeQuery', // 109
	'preloadOperationsQuery', // 110
	'preloadPageStatusQueryDataQuery', // 111
	'preloadPersonalSpaceDetailsQuery', // 112
	'preloadShareAndRestrictButtonQuerySpaceOverviewQuery', // 113
	'preloadSpaceBlogCountQuery', // 114
	'preloadTemplatesCollectionEligibleQuery', // 115
	'requireSuperBatchFrontendResourceRenderQuery', // 116
	'rightPanel', // 117
	'searchCombinedConfig', // 118
	'searchResults', // 119
	'sidenavSmartLinksORS', // 120
	'useAnalyticsByLineQuery', // 121
	'useAudioContentQuery', // 122
	'useConfluenceStandardToPremiumExperimentQuery', // 123
	'useContentClassificationContentDataClassificationQuery', // 124
	'useEditorContentModeValueQuery', // 125
	'useEmojiEverSetPropertyQuery', // 126
	'useFabricEligibilityMigrationQuery', // 127
	'useFeatureDiscoveryFeatureDiscoveryQuery', // 128
	'useFeedTypeSelectorRefreshQuery', // 129
	'useFollowingFeedWithSortByStorageFeedContentQuery', // 130
	'useGetCurrentStorageUsageQuery', // 131
	'useGetTeamAndSubanchorGetPersonalSpaceKeyQuery', // 132
	'useGetTeamAndSubanchorGetSubanchorsAGGQuery', // 133
	'useHomeWidgetStateQuery', // 134
	'useIsEligibleForNthUserHomeOnboardingLicensedUserCountQuery', // 135
	'useIsLoomEntryPointsEnabledQuery', // 136
	'useIsUserViewingSpaceAsAnonQuery', // 137
	'useLicensedProductsQueryForGlobalAppShortcutsQuery', // 138
	'useLoomTenantProvisionStatusQuery', // 139
	'usePopularFeedWithTimeGranularityStorageQuery', // 140
	'usePreloadCommentButtonQuery', // 141
	'useReadTimeQuery', // 142
	'useRegisterAdminAnnouncementBannerQuery', // 143
	'useShareAndRestrictButtonDataQuery', // 144
	'useShortcutsSpaceNavigationQuery', // 145
	'useSpaceBaseQueryBaseQuery', // 146
	'useSpaceDetailQuery', // 147
	'useSpaceEnabledContentTypesQuery', // 148
	'useSpaceViewsDataSpaceRootQuery', // 149
	'useSpaceViewsOptionsPersistenceQuery', // 150
	'useSpacesDataAnonymousSpacesQuery', // 151
	'useSpacesDataMyVisitedSpacesQuery', // 152
	'useSpacesDataStarredSpacesQuery', // 153
	'useTitleContentPropertiesForEditorQuery', // 154
	'useTitleContentPropertiesForPublishedPagePreloadHomepageIdQuery', // 155
	'useTitleContentPropertiesForPublishedPageQuery', // 156
	'useUserByLicensedProductsQuery', // 157
];

// prettier-ignore
export const R: Readonly<Record<string, string>> = {
	'prod-apne': '9dff7b77fa5efbffdfb27fdfffffb7fe7bef7f1e', /* 129 fast, 17 slow, 8 excl */
	'prod-apne2': 'bdff7bf7fa5efbffdfb67bdff7ffa6fe6bef7f1e', /* 127 fast, 20 slow, 26 excl */
	'prod-apse': '9dff7bf7fb5fffffdfb67fffffffbffe7befff3e', /* 138 fast, 13 slow, 6 excl */
	'prod-apse2': 'bdff7bf7fa5fffffdfbe7fffffffbffe73efff3f', /* 139 fast, 12 slow, 13 excl */
	'prod-apsouth': 'b5fffb77fa5efbffdfba7fffffffafbe7bef7f3f', /* 133 fast, 11 slow, 51 excl */
	'prod-cacentral': 'bdff7b77fb7fffffdfbe7fffffffaffefbef7f3f', /* 140 fast, 7 slow, 5 excl */
	'prod-east': 'bdff7ff7fb7fffffdfbe7fffffffbffefbefff3f', /* 144 fast, 9 slow, 69 excl */
	'prod-eucentral': 'bfff7ff7fb5fffffdfb67fffffffbffc7befff3e', /* 140 fast, 13 slow, 102 excl */
	'prod-eucentral2': '20cc7102f04833fc11b0781f9e5c03483b84040e', /* 64 fast, 79 slow, 9 excl */
	'prod-euwest': 'bfff7ff7fb7fffffdfbe7fffffffbffefbefff3f', /* 145 fast, 9 slow, 58 excl */
	'prod-euwest2': 'bdff7bf7fb7fffffdfbe7fffffffaffefbef7f3f', /* 141 fast, 7 slow, 10 excl */
	'prod-west2': '9dff7ff7fe7fffffdfbe7fffffffbffefbefff3f', /* 143 fast, 9 slow, 86 excl */
	'stg-east': '76b7fb7fe877dde6ffefff3e5ff7abfffbeffb37', /* 126 fast, 15 slow, 52 excl */
};
